/* eslint-disable */

const noOp = () => { };

export default class Deferred<T> {
    public resolve: (value: T | PromiseLike<T>) => void = noOp;
    public reject: (reason?: any) => void = () => noOp;
    public promise: Promise<T>;

    constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}